import type { ServicePhase } from "@/data/service";

export function PhaseCard({ phase }: { phase: ServicePhase }) {
  return (
    <article className="rounded-xl border border-[var(--line)] bg-paper p-5 shadow-card">
      <div className="mb-3.5 flex items-center gap-3.5">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-forest-100 font-mono text-sm font-semibold tracking-wide text-forest-900">
          {String(phase.n).padStart(2, "0")}
        </div>
        <div>
          <h3 className="text-[19px] font-bold leading-none tracking-tight text-ink-900">
            {phase.title}
          </h3>
          <p className="mt-1 font-mono text-[10.5px] uppercase tracking-[0.14em] text-ink-400">
            {phase.sub}
          </p>
        </div>
      </div>
      <p className="mb-4 text-[13.5px] leading-[1.7] text-ink-600">{phase.desc}</p>
      <ul className="flex flex-col gap-2">
        {phase.items.map((item) => (
          <li key={item} className="flex items-start gap-2.5 text-[13px] leading-snug text-ink-700">
            <svg
              className="mt-0.5 shrink-0"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              aria-hidden
            >
              <path
                d="M3 7l3 3 5-6"
                stroke="#229571"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </article>
  );
}
